import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  QueryKeys,
  useAppLocation,
  useAppState,
  useAppTranslation,
} from "../../../common";
import { ErrorModal, Modal } from "../../../components";
import { deleteTierAction } from "../../../actions";

type TierDeleteModalProps = {
  handleDeleteModalVisible: () => void;
};

export function TierDeleteModal(props: TierDeleteModalProps) {
  const { t } = useAppTranslation();
  const location = useAppLocation();

  const queryClient = useQueryClient();
  const [state, setState] = useAppState({
    errorModalVisible: false,
  });

  const handleModalVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      errorModalVisible: !prevState.errorModalVisible,
    }));
  };

  const deleteTier = useMutation({
    mutationKey: [QueryKeys.deleteTierQuery],
    mutationFn: deleteTierAction,
    onSuccess() {
      props.handleDeleteModalVisible();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.tierQuery] });
    },
    onError() {
      handleModalVisibility();
    },
  });

  const handleDeleteTier = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deleteTier.mutate({ id: location.state?.id });
  };

  return (
    <div>
      <section>
        <Modal
          onClose={props.handleDeleteModalVisible}
          title={t("tier-page-delete-modal-title")}
          footer
          submitText={t("tier-page-delete-submit-button-title")}
          cancelText={t("tier-page-delete-cancel-button-title")}
          handleSubmit={handleDeleteTier}
          loading={deleteTier.isPending}
        >
          <span>{t("tier-page-delete-tier-question-label")}</span>
        </Modal>
      </section>
      <section>
        {state.errorModalVisible && (
          <ErrorModal
            error={deleteTier.error}
            onClose={handleModalVisibility}
            title={t("tier-page-delete-tier-error-modal-title")}
          />
        )}
      </section>
    </div>
  );
}
